export const getSearchParams = (_param, _defaultValue) => {
  const urlParams = new URLSearchParams(window?.location?.search)

  return urlParams.get(_param)
    ? urlParams.get(_param)
    : _defaultValue
    ? _defaultValue
    : undefined
}
